import React from 'react';

import { appMethod as app } from '@utils/app';

import './ExchangeCouponCustomComponent.less';

/**
 * type: 'exchange-coupon'
 * 组件：可兑换券组件
 */
export default class ExchangeCouponCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    const compindex = props.index;
    const pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let compData = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    let param = {};
    let url = '/index.php?r=AppShop/getCoupons';
    let fieldData = {};

    param.in_show_list = 1;
    param.enable_status = 1;
    param.stock = 1;
    param.exchangeable = 1;
    param.page_size = customFeature.loadingNum || 10;
    param.page = 1;
    param.is_integral = customFeature.isIntegral ? 1 : 0;
    
    fieldData['eles[' + compindex + '].param'] = param;
    fieldData['eles[' + compindex + '].loading'] = true;
    fieldData['eles[' + compindex + '].loadingFail'] = false;
    fieldData['eles[' + compindex + '].list_data'] = [];
    fieldData['eles[' + compindex + '].is_more'] = 1;
    fieldData['eles[' + compindex + '].curpage'] = 0;
    pageInstance.setData(fieldData);

    app.sendRequest({
      hideLoading: true,
      url: url,
      data: param,
      method: 'post',
      success: function (res) {
        if (res.status == 0) {
          let newdata = {};
          newdata['eles[' + compindex + '].list_data'] = res.data;
          newdata['eles[' + compindex + '].is_more'] = res.is_more;
          newdata['eles[' + compindex + '].curpage'] = 1;
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;
          pageInstance.setData(newdata);
        }
      },
      fail: function(res){
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  }

  exchangeCouponScrollFunc = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex    = typeof event == 'object' ? event.currentTarget.dataset.compindex : event;
    let compData     = pageInstance.data.eles[compindex];
    let curpage      = compData.curpage + 1;
    let customFeature = compData.customFeature;
    let newdata      = {};
    let param        = {};
    if(!compData.is_more && typeof event == 'object' && event.type == 'tap'){
      app.showModal({
        content: '已经加载到最后了'
      });
    }
    if (compData.loading || !compData.is_more) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);

    param = compData.param;
    param.page_size = +customFeature.loadingNum || 10;

    param.page = curpage;
    app.sendRequest({
      url: '/index.php?r=AppShop/getCoupons',
      data: param,
      method: 'post',
      hideLoading: true,
      success: function (res) {
        newdata = {};
        let rdata = res.data,
            downcountArr = pageInstance.downcountArr || [];

        for (let i = 0; i < rdata.length; i++) {
          let f = rdata[i],
              dc ,
              idx = (curpage-1) * param.page_size + i;

          f.downCount = {
            hours : '00' ,
            minutes : '00' ,
            seconds : '00'
          };
          if(f.seckill_start_state == 0){
            dc = app.beforeSeckillDownCount(f , pageInstance , compindex + '.list_data[' + idx + ']');
          }else if(f.seckill_start_state == 1){
            dc = app.duringSeckillDownCount(f , pageInstance , compindex + '.list_data[' + idx + ']');
          }
          dc && downcountArr.push(dc);
        }
        newdata['eles[' + compindex + '].list_data'] = compData.list_data.concat(res.data);
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = res.current_page;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.downcountArr = downcountArr;

        pageInstance.setData(newdata);
      },
      fail: function () {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function () {
      }
    })
  }

  turnToexchangeCouponDetail = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = event.currentTarget.dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    app.globalData.exchangeCouponStyle = compData;
    let dataset   = event.currentTarget.dataset;
    let id        = dataset.id;
    let recv_status = dataset.status;
    // if (recv_status == 0) {
    //   app.showModal({content: '超过可兑换次数'});
    //   return
    // }
    app.turnToPage('/exchangeCoupon/pages/exchangeCouponDetail/exchangeCouponDetail?id=' + id);
  }

  getexchangeCoupon = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    app.globalData.exchangeCouponStyle = compData;
    let coinid = dataset.coinid;
    let index = dataset.index;
    let recv_status = dataset.status;
    let money = dataset.money ? + dataset.money : 0;
    let limitNum = dataset.limitnum ? + dataset.limitnum : 0;
    let userRecvNum = dataset.userrecvnum ? + dataset.userrecvnum : 0;

    if (recv_status == 0) {
      app.showModal({content: '超过可兑换次数'});
      return
    }
    if (money && money > 0) {
      app.turnToPage('/exchangeCoupon/pages/exchangeCouponDetailOrder/exchangeCouponDetailOrder?id=' + coinid);
      return;
    }
    app.showModal({
      title: '是否确认兑换？',
      content: '注：兑换成功后不支持退换',
      showCancel: true,
      cancelText: "否",
      confirmText: "是",
      confirm:  () => {
        this.checkexchangeCoupon(coinid, compindex, index, limitNum, userRecvNum);
      }
    })
  }

  checkexchangeCoupon = (coinid, compindex, index, limitNum, userRecvNum) => {
    let pageInstance = app.getAppCurrentPage();
    app.sendRequest({
      url: '/index.php?r=appCoupon/addCouponOrder',
      data: {
        'id': coinid
      },
      method: 'post',
      hideLoading: true,
      success: function(res) {
        app.showToast({
          title: '兑换成功',
          icon: 'none',
          duration: 1000
        })
        if (limitNum >= userRecvNum + 1) {
          let newdata = {};
          newdata['eles[' + compindex + '].list_data[' + index + '].user_recv_num'] = userRecvNum + 1
          pageInstance.setData(newdata);
        } else {
          let newdata = {};
          newdata['eles[' + compindex + '].list_data[' + index + '].recv_status'] = 0
          pageInstance.setData(newdata);
        }
      },
      complete: function (res) {
        // if (res.status === 0) {
        //   return
        // }
        // let newdata = {};
        // newdata[id+'.list_data[' + index + '].recv_status'] = 0
        // pageInstance.setData(newdata);
      }
    })
  }

  render() {
    const data = this.props.data;
    const { customFeature, list_data = [] } = data;
    let {
      margin, lineBackgroundColor, secColor
    } = customFeature;
    secColor = secColor.replace(/;+/g, '');

    /**
     * @desc 优惠券列表
     */
    const couponItem = (item, index) => {
      return (
        <div className="exchange-coupon-wrapper" style={{ backgroundColor: lineBackgroundColor }}>
          {item.stock != 0 && <div className="exchange-coupon-linetop" style={{ backgroundColor: item.stock != 0 ? secColor : '#cccccc' }}></div>}
          {/* 优惠券头部 */}
          <div className="exchange-coupon-top">
            <div className="exchange-coupon-left">
              <div className="exchange-coupon-left-first">{item.title}</div>
              <div className="exchange-coupon-left-second" style={{ color: item.stock == 0 ? '#333' : '' }}>
                {item.exchange_condition.price > 0 && <span>¥{item.exchange_condition.price}</span>}
                {item.exchange_condition.price > 0 && item.exchange_condition.integral > 0 && <span>+</span>}
                {item.exchange_condition.integral > 0 && <span>{item.exchange_condition.integral}积分</span>}
              </div>
            </div>
            <button
              className="exchange-coupon-right"
              style={{ backgroundColor: secColor }}
              data-coinid={item.id}
              data-limitnum={item.limit_num}
              data-userrecvnum={item.user_recv_num}
              data-index={index}
              data-status={item.recv_status}
              data-money={item.exchange_condition.price}
              data-compindex={this.props.index}
              onClick={(e) => {this.getexchangeCoupon(e);e.stopPropagation()}}>
              {item.stock != 0 && item.user_recv_num == 0 ? '立即兑换' : '再次兑换'}
            </button>
            {item.stock == 0 && <div className="exchange-coupon-right-used" >已抢完</div>}
            {counponIcon(item)}
            <div className="exchange-coupon-icon-wrapper" style={{ borderColor: item.stock != 0 ? secColor: '#ccc' }}></div>
          </div>
          {/* 优惠券底部 */}
          <div className="exchange-coupon-bottom">
            {/* <div className="exchange-coupon-cut"></div> */}
            {item.expire == '-1' &&
            <span className="exchange-coupon-expire-time">
              有效期 {item.start_use_date}至{item.end_use_date} {item.exclude_holiday == 0 ? '' : '除去法定节假日'} {item.exclude_weekend == 0 ? '' : '周一至周五'} {item.start_use_time}-{item.end_use_time}
            </span>
            }
            {item.expire != '-1' &&
            <span className="exchange-coupon-expire-time">
              有效期 {item.expire == '0' ? '领取当天生效,有效期1天' : ('领取' + (item.react > 0 ? item.react + '天后' : '当天') + '生效，有效期' + item.expire + '天')}{item.exclude_holiday == 0 ? '' : '除去法定节假日'} {item.exclude_weekend == 0 ? '' : '周一至周五'} {item.start_use_time}-{item.end_use_time}
            </span>
            }
          </div>
        </div >
      )
    }

    /**
     * @desc 优惠券类型图标icon
     */
    const counponIcon = (item) => {
      const type = {
        0: '减', 1: '折', 2: '代',
        3: '兑', 4: '储', 5: '通',
        6: '次'
      };
      return (
        <div className={`exchange-coupon-icon ${ item.stock == 0 ? 'exchange-coupon-icon-used' : '' }`} style={{ backgroundColor: secColor }}>
          <div>{type[item.type]}</div>
        </div>
      )
    }


    return (
      <div className="custom-component exchange-coupon">
        {
          list_data.map((item, index) => {
            return (
              <div
                className="exchange-coupon-item background-ele"
                key={item.id}
                style={{ marginBottom: `${margin}px` }}
                data-compindex={this.props.index}
                data-id={item.id}
                data-status={item.recv_status}
                onClick={this.turnToexchangeCouponDetail}>
                {couponItem(item, index)}
              </div>
            )
          })
        }
        { !list_data.length &&
        <div className="no-data">
          <img src="http://cdn.jisuapp.cn/static/webapp/images/request-none.png" />
          <p>你还未添加可兑换优惠券~</p>
        </div>
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/exchange-coupon-custom-component/ExchangeCouponCustomComponent.jsx